export default import.meta.ROLLDOWN_FILE_URL_a9NWV7ZzUDnozeb69v11FQ